// extracted by mini-css-extract-plugin
export default {"collection":"DndCollections_collection__V9NIz","collectionDropZone":"DndCollections_collectionDropZone__t3c75"};